/* eslint-disable array-callback-return */

import validateRegistration from '../services/validation/Registration'

import convertDataURIToBlob from '../services/binaries/convertDataURIToBlob'

import * as RegisterApiService from '../services/api/requests/Register'
import * as CardApiService from '../services/api/requests/Card'
import * as PreferenceApiService from '../services/api/requests/Preferences'

import { setGACustomEvent } from '../services/analytics/google-analytics'
import getErrorType from '../services/data/getCardErrorType'
import {
  // getSSOToken,
  encodeSSOData,
  saveSSOData,
  isClientVerified,
  deleteSSOVerification,
  // decodeSSOData,
  getCredentials,
} from '../services/data/sso'
import {
  ADD_CARD,
  DETAILS,
  OTP,
  AVATAR,
  PREFERENCES,
} from '../services/data/registrationSteps.json'
import { doRequestSSOCode } from './Login'
import { getCurrentTimeStamp } from '../services/data/dateFormat'

const SUCCESS_URL = `${process.env.REACT_APP_BASE_URL}/tpa-redirect/add-card/success`
const FAIL_URL = `${process.env.REACT_APP_BASE_URL}/tpa-redirect/add-card/fail`

export const CRM_STEPS = {
  PROFILE: 1,
  OTP: 2,
}

export const doHandleSSORedirection = async (
  searchString,
  redirectToThirdParty,
  accessToken,
  nativeRedirect,
) => {
  if (searchString && redirectToThirdParty) {
    let thisCode = undefined
    const { redirectUri, responseType, clientId } = await getCredentials(
      searchString,
    )

    if (responseType === 'code' && accessToken && clientId) {
      thisCode = await doRequestSSOCode({ accessToken, clientId })
    }

    await redirectToThirdParty(redirectUri, thisCode)
  } else nativeRedirect && (await nativeRedirect())
}

// ST-2873
export const doSendRegisterOTP = async ({
  registrationToken,
  searchString,
  push,
}) => {
  try {
    await RegisterApiService.postRegisterOTP({
      registrationToken,
    })
    push(`/register/otp${searchString || ''}`)
  } catch (e) {}
}
export const doSavePrimaryInfoV1 = ({
  setPrimaryInfo,
  setToken,
  setStep,
  push,
  googleToken,
  appleId,
  searchString,
}) => async (values, state) => {
  state.setSubmitting(true)
  const {
    firstName,
    lastName,
    email,
    mobileNumber,
    referralCode,
    avatarUrl,
  } = values
  try {
    const registerResponse = await RegisterApiService.postRegisterV1({
      firstName,
      lastName,
      email,
      mobileNumber,
      googleToken,
      appleId,
      avatarUrl,
    })
    const { registrationToken, user } = registerResponse.data
    setToken(registrationToken)
    setPrimaryInfo(user)

    if (referralCode) {
      try {
        const { data } = await RegisterApiService.postRegisterReferral({
          registrationToken,
          code: referralCode,
        })
        if (!data.data.valid) {
          throw new Error('Invalid referral code')
        } else {
          setStep(OTP)
          await doSendRegisterOTP({ registrationToken, searchString, push })
        }
      } catch (error) {
        const { message, response } = error
        const errorMessage = response?.data?.message || message
        state.setFieldError('referralCode', errorMessage)
      }
    } else {
      setStep(OTP)
      await doSendRegisterOTP({ registrationToken, searchString, push })
    }
  } catch (error) {
    const { data = {} } = error.response || {}
    const { message } = data || {}

    state.setSubmitting(false)
    state.setStatus({
      error: 'There was an error processing your request',
    })

    if (Array.isArray(message)) {
      state.setStatus({})
      message.map(m => {
        if (m.toLowerCase().indexOf('first name') >= 0) {
          state.setFieldError('firstName', m)
          return
        }
        if (m.toLowerCase().indexOf('last name') >= 0) {
          state.setFieldError('lastName', m)
          return
        }
        if (m.toLowerCase().indexOf('mobile') >= 0) {
          state.setFieldError('mobile', m)
          return
        }
        if (m.toLowerCase().indexOf('email') >= 0) {
          state.setFieldError('email', m)
          return
        }
        state.setStatus({ error: m })
      })
    } else {
      message &&
        state.setStatus({
          error: message,
        })
    }
  }
}

export const doValidateRegistrationForm = () => async data => {
  const validation = await validateRegistration(data)

  if (!validation.email) {
    validation.email = 'Error in validating email. Check your network services.'
    try {
      const response = await RegisterApiService.getEmailValidity(data.email)

      if (response.status === 200) {
        delete validation.email
      }
    } catch (error) {
      if (error.message !== 'Network Error') {
        const { data: errorData } = error.response

        validation.email = errorData.message
      }
    }
  }

  if (!validation.mobileNumber) {
    // mobile number already validated from register landing, before register user details
    // validation.mobileNumber =
    //   'Error in validating mobile number. Check your network services.'
    // try {
    //   const response = await RegisterApiService.getMobileNumberValidity(
    //     data.mobileNumber,
    //   )
    //   if (response.status === 200) {
    //     delete validation.mobileNumber
    //   }
    // } catch (error) {
    //   if (error.message !== 'Network Error') {
    //     const { data: errorData } = error.response
    //     validation.mobileNumber = errorData.message
    //   }
    // }
  }
  // console.debug(validation)
  throw validation
}

export const doVerifyOtp = ({
  token: registrationToken,
  firebaseMessagingToken,
  setAccessToken,
  setStep,
  push,
  searchString,
  setShowErrorModal,
  setFirstSpinModalOpen,
}) => async (values, state) => {
  state.setSubmitting(true)

  if (searchString && !isClientVerified()) {
    state.setStatus({
      error: 'Client not verified.',
    })

    return
  }

  try {
    const { code } = values
    const { clientId } = await getCredentials(searchString)
    const otpResponse = await RegisterApiService.postVerifyOtp(
      {
        code,
        registrationToken,
        clientId,
      },
      firebaseMessagingToken,
    )

    const {
      accessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
      user,
    } = otpResponse.data
    const { googleId, appleId } = user
    const token = encodeSSOData({
      accessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
    })

    setAccessToken(accessToken)
    saveSSOData(token)
    deleteSSOVerification()
    setFirstSpinModalOpen(true)
    let registrationMethod = 'native'
    if (googleId || appleId) {
      if (googleId) registrationMethod = 'google'
      if (appleId) registrationMethod = 'apple'
    }

    await setGACustomEvent('registration_successful', {
      time_stamp: getCurrentTimeStamp(),
      method: registrationMethod,
      mobile_number: values.mobileNumber,
    })

    state.setSubmitting(false)
    localStorage.removeItem('popup-index')
    await setStep(ADD_CARD)

    push({
      pathname: '/register/success',
      search: searchString,
      state: { registrationStep: ADD_CARD },
    })
    // push(`/register/success${searchString}`)
  } catch (error) {
    const { data = {} } = error.response || {}
    const { message } = data || {}
    const { message: jsonMessage } = error.toJSON()

    if (jsonMessage.includes('504')) {
      setShowErrorModal(true)
    }

    state.setStatus({
      error:
        message || jsonMessage || 'There was an error processing your request',
    })
  }
  state.setSubmitting(false)
}

export const doResendOtp = async ({ token, toMobile = true }) => {
  try {
    await RegisterApiService.postRegisterOtpResend({ token, toMobile })
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}
    console.log(`Status: ${status} | Message: ${message}`)

    // state.setStatus({
    //   status,
    //   error: message,
    // })
  }
}

export const doUploadAvatar = ({
  accessToken,
  setStep,
  setPrimaryInfo,
  push,
  redirectAfterAuth,
  saveAccessToken,
  redirectToThirdParty,
  searchString,
}) => async (values, state) => {
  state.setSubmitting(true)

  const { displayPhoto } = values

  try {
    const response = await RegisterApiService.postAvatar(
      { image: convertDataURIToBlob(displayPhoto) },
      { accessToken },
    )

    if (saveAccessToken) saveAccessToken(accessToken)
    if (setPrimaryInfo) setPrimaryInfo(response.data)

    //sso redirection
    const nativeRedirect = async () => {
      if (setStep) setStep(PREFERENCES)
      if (setPrimaryInfo) setPrimaryInfo(response.data)
      if (push) await push(redirectAfterAuth || '/')
    }
    // const token = await getSSOToken()
    // const { code } = await decodeSSOData(token)
    await doHandleSSORedirection(
      searchString,
      redirectToThirdParty,
      accessToken,
      nativeRedirect,
    )
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}

export const doHandleOnLoad = ({
  accessToken,
  rerender,
  setCardAdded,
  setShowAddPage,
  setAddCardError,
  setCardList,
  setShowSuccessModal,
  setRerender,
  setCardsError,
  cardErrorDefaultType,
}) => async e => {
  const successRegExp = new RegExp(SUCCESS_URL)
  const failRegExp = new RegExp(FAIL_URL)

  setCardAdded({})

  const iFrame = e.currentTarget

  try {
    const redirectUrl = e.target.contentWindow.location.href
    if (!successRegExp.test(redirectUrl) && !failRegExp.test(redirectUrl)) {
      iFrame.style.height = `${iFrame.contentWindow.document.body.scrollHeight}px`
    }
  } catch (error) {}

  try {
    const redirectUrl = e.target.contentWindow.location.href

    if (successRegExp.test(redirectUrl)) {
      setShowAddPage(false)
      setAddCardError('')
      // REMOVED - postOnboardingEmail function no longer exists
      // try {
      //   await RegisterApiService.postOnboardingEmail(1, accessToken)
      // } catch (error) {}
      try {
        const response = await CardApiService.getAllCards(accessToken)
        const lastCard = [...response.data].pop()

        setCardList(response.data)
        setCardAdded(lastCard)
        setShowSuccessModal(true)
        setCardsError(cardErrorDefaultType)
      } catch (error) {
        const { data: errorData = {} } = error.response || {}
        const { message = 'Network Error' } = errorData || {}
        setCardList([])
        setCardsError({
          cardError: {
            type: getErrorType(message),
            display: true,
          },
        })
      }
    } else if (failRegExp.test(redirectUrl)) {
      const urlString = redirectUrl
      const url = new URL(urlString)
      const addCardErrorMessage = url.searchParams
        .get('message')
        .replace(/[+]/g, ' ')

      setRerender(rerender + 1)
      setAddCardError(addCardErrorMessage)
    }
  } catch (error) {}
}

export const doDeleteCard = ({
  accessToken,
  cardList,
  setCardList,
}) => async id => {
  try {
    await CardApiService.deleteCard(id, accessToken)

    setCardList(cardList.filter(card => card.id !== id))
  } catch (error) {}
}

export const doContinueAddCard = ({
  accessToken,
  redirectAfterAuth,
  saveAccessToken,
  setStep,
  push,
  sendOnboarding,
  primaryInfo = {},
  searchString,
  redirectToThirdParty,
}) => async () => {
  // REMOVED - postOnboardingEmail function no longer exists
  // if (sendOnboarding) {
  //   try {
  //     await RegisterApiService.postOnboardingEmail(0, accessToken)
  //   } catch (error) {}
  // }

  setGACustomEvent('button_cta', {
    screen_name: 'Registration - Card Linkings',
    button_name: 'Add Later',
  })

  const { googleId, appleId } = primaryInfo || {}
  if (googleId || appleId) {
    //sso redirection
    if (saveAccessToken) saveAccessToken(accessToken)
    const nativeRedirect = async () => {
      setStep(0)
      await push(redirectAfterAuth || '/')
    }
    // const token = await getSSOToken()
    // const { code } = await decodeSSOData(token)
    await doHandleSSORedirection(
      searchString,
      redirectToThirdParty,
      accessToken,
      nativeRedirect,
    )
  } else {
    setStep(AVATAR)
    push(`/register/avatar${searchString || ''}`)
  }
}

export const doGetApiKey = ({
  accessToken,
  setApiKey,
  setProgramCode,
}) => async () => {
  try {
    const response = await CardApiService.postToken(accessToken)

    if (response.data.token) {
      setApiKey(response.data.token)
      setProgramCode(response.data.programCode)
    }
  } catch (error) {}
}

export const doGetPreferences = ({ setPreferences }) => async () => {
  try {
    const preferenceResponse = await PreferenceApiService.getPreferences()

    setPreferences(preferenceResponse.data)
  } catch (error) {}
}

export const doSubmitPreferences = ({
  push,
  accessToken,
  saveAccessToken,
  setPreferenceIds,
  redirectAfterAuth,
}) => async (values, state) => {
  state.setSubmitting(true)
  try {
    const { preferences } = values
    const selectedPreferences = preferences
      .map((pref, index) => (pref ? index : ''))
      .filter(pref => pref)

    await PreferenceApiService.postPreferences(
      {
        ids: selectedPreferences,
      },
      { accessToken },
    )
    saveAccessToken(accessToken)
    // ST-3117 save preference in user primary info
    setPreferenceIds(selectedPreferences)

    push(redirectAfterAuth || '/')
  } catch (err) {
    state.setStatus({
      error: 'There was an error processing your request',
    })
  }
  state.setSubmitting(false)
}

export const doLoadCardList = ({
  accessToken,
  setCardList,
  setCardsError,
  cardErrorDefaultType,
}) => async () => {
  try {
    const { data: cardsData } = await CardApiService.getAllCards(accessToken)
    setCardList(cardsData)
    setCardsError(cardErrorDefaultType)
  } catch (error) {
    const { data: errorData = {} } = error.response || {}
    const { message = 'Network Error' } = errorData || {}
    setCardList([])
    setCardsError({
      cardError: {
        type: getErrorType(message),
        display: true,
      },
    })
  }
}

// SIMPLIFIED REG
export const doValidateMobile = ({
  push,
  appleId,
  googleToken,
  setStep,
  setToken,
  searchString,
  setPrimaryInfo,
}) => async (values, state) => {
  const { username } = values
  const { setStatus, setSubmitting } = state

  setStatus({})
  setSubmitting(true)
  try {
    setGACustomEvent('button_cta', {
      screen_name: 'Registration - Mobile Number',
      button_name: 'Register',
    })
    const response = await RegisterApiService.getMobileNumberValidity(username)
    if (response.status === 200) {
      // call post register
      try {
        const registerResponse = await RegisterApiService.postRegisterProfile({
          appleId,
          googleToken,
          mobileNumber: username,
        })
        const { registrationToken } = registerResponse.data
        setToken(registrationToken)
        //setPrimaryInfo(user)
      } catch (error) {
        const { data: errorData, status } = error.response

        setStatus({
          status,
          error: errorData.message,
        })
      }
      // success. proceed registration
      setStep(DETAILS)
      push({
        pathname: `/register/details`,
        search: searchString,
        state: { mobileNumber: username },
      })
    }
  } catch (error) {
    if (error.message !== 'Network Error') {
      const { data: errorData, status } = error.response

      setStatus({
        status,
        error: errorData.message,
      })
    }
  }

  setSubmitting(false)
}

export const doSavePrimaryInfo = ({
  push,
  setStep,
  searchString,
  setPrimaryInfo,
  token: registrationToken,
}) => async (values, state) => {
  state.setSubmitting(true)
  const { firstName, lastName, email, referralCode, avatarUrl } = values

  try {
    let referralError = false
    if (referralCode) {
      try {
        const response = await RegisterApiService.checkReferralCode(
          referralCode,
        )
        if (!response.data.valid) {
          throw new Error('Invalid referral code')
        }
      } catch (error) {
        const { message, response } = error
        const errorMessage = response?.data?.message || message
        state.setFieldError('referralCode', errorMessage)
        referralError = true
      }
    }

    if (!referralError) {
      try {
        const registerResponse = await RegisterApiService.putRegisterProfile({
          firstName,
          lastName,
          email,
          referralCode,
          avatarUrl,
          registrationToken,
        })
        const { user } = registerResponse.data
        setPrimaryInfo(user)
        setStep(OTP)

        // redirect to OTP screen
        push({
          pathname: `/register/otp`,
          search: searchString,
        })
      } catch (error) {
        const { data = {} } = error.response || {}
        const { message } = data || {}

        state.setStatus({
          error: 'There was an error processing your request',
        })

        if (Array.isArray(message)) {
          state.setStatus({})
          message.map(m => {
            if (m.toLowerCase().indexOf('first name') >= 0) {
              state.setFieldError('firstName', m)
              return
            }
            if (m.toLowerCase().indexOf('last name') >= 0) {
              state.setFieldError('lastName', m)
              return
            }
            if (m.toLowerCase().indexOf('mobile') >= 0) {
              state.setFieldError('mobile', m)
              return
            }
            if (m.toLowerCase().indexOf('email') >= 0) {
              state.setFieldError('email', m)
              return
            }
            state.setStatus({ error: m })
          })
        } else {
          message &&
            state.setStatus({
              error: message,
            })
        }
      }
    }
  } catch (error) {}

  state.setSubmitting(false)
}
